// extracted by mini-css-extract-plugin
module.exports = {"host":"BaseButton_host__1fXzM","danger":"BaseButton_danger__2nRlc","progressbar":"BaseButton_progressbar__3zL6r"};